import app from 'flarum/forum/app';
import addFooter from './extenders/addFooter';
import addSectionHeroes from './extenders/addSectionHeroes';
import customizePoll from './extenders/customizePoll';
export { default as extend } from './extend';

// The homepage route is registered declaratively via Extend.Routes in
// ./extend.ts (the canonical Flarum 2.x mechanism). Imperative side-effects
// like the footer injection and listing-page hero overrides stay here in the
// initializer.
app.initializers.add('glowingblue-demo', () => {
  addFooter();
  customizePoll();
});

// fof/follow-tags also override()s IndexPage.prototype.hero to render its own
// FollowingHero on the `following` route. Flarum's override() makes the LAST
// applied wrapper the outermost (it runs first and decides whether to call the
// inner one), so whichever initializer runs later wins. follow-tags registers
// at the default priority (0); register ours LOWER so it runs last and our
// brand SectionHero wins on every IndexPage route — Discussions and Following.
app.initializers.add('glowingblue-demo-heroes', () => addSectionHeroes(), -100);